






import { mapState } from 'vuex'
import { CLASSIFIED_SEARCH_NS } from '~/store/modules/shared/classifieds/search/state'
import MapSearch from '~/components/car/classifieds/search/map-search/MapSearch.vue'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import SearchService from '~/services/search/SearchService'
import {
  defineComponent,
  onBeforeUnmount,
  useContext,
  useRoute,
  useStore
} from '~/utils/nuxt3-migration'
import { USER_NS } from '~/store/modules/shared/user/state'
import { useDep } from '~/compositions/dependency-container'

export default defineComponent({
  name: 'MapSearchPage',
  components: { MapSearch },
  async asyncData({ $dep, store, route, redirect, error }) {
    const isMobile = store.getters[`${USER_AGENT_NS}/isMobile`]

    const searchService = $dep(SearchService)

    if (isMobile && route.params.slugOrId) {
      return redirect(`/${route.params.slugOrId}`)
    }

    await searchService.createSearch({
      route,
      mapSearch: true,
      errorFn: error
    })

    return {
      search: true
    }
  },
  data() {
    return {
      isMapSearchActive: true,
      search: null
    }
  },
  computed: {
    ...mapState(CLASSIFIED_SEARCH_NS, ['searchId'])
  },
  setup() {
    const store = useStore()
    const route = useRoute()
    const { error } = useContext()
    const searchService = useDep(SearchService)

    const unsubscribe = store.subscribeAction({
      after: async action => {
        if (!process.client) {
          return
        }
        if (action.type === `${USER_NS}/loadUserSubscribable`) {
          await searchService.createSearch({
            route: route.value,
            errorFn: error,
            mapSearch: true
          })
        }
      }
    })

    onBeforeUnmount(() => {
      unsubscribe()
    })
  },
  deactivated() {
    if (this.$route.name === '__index') {
      this.isMapSearchActive = false
      this.search = null
    }
  },
  activated() {
    this.isMapSearchActive = true
    const searchService = this.$dep(SearchService)

    if (!this.search) {
      searchService.createSearch({
        route: this.$route,
        mapSearch: true,
        errorFn: this.$error
      })
    }
  },
  head() {
    const headService = this.$dep(SearchService)
    return headService.createSearchHead(this.$route)
  }
})
